import {FunctionalComponent, Host, h} from '@stencil/core';

export const Hidden: FunctionalComponent = () => (
  <Host class="atomic-hidden"></Host>
);
